import { render, staticRenderFns } from "./addMyComplaints.vue?vue&type=template&id=09ee10a8&scoped=true&"
import script from "./addMyComplaints.vue?vue&type=script&lang=js&"
export * from "./addMyComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ee10a8",
  null
  
)

export default component.exports